module.exports = __webpack_public_path__ + "static/media/SPA.1f02a5e8.jpg";